<template>
  <div>
    <div class="pop-payment-wrap">
      <div class="pop-header">
        <span class="pop-title">영수증 관리</span>
        <button class="btn-pop-close" @click="$.emit('close')">
          닫기<span class="overlay"></span>
        </button>
      </div>
      <div class="pop-body">
        <div class="fieldset">
          <span class="h2">영수증 조회</span>
          <div class="ip-row col04">
            <label for="date">매출일자</label>

            <Datepicker
              v-model="date"
              :style="pickerStyle"
              class="datepicker startDate ip-comm center"
            ></Datepicker>
            <label for="rtNum03">포스번호</label>
            <input
              type="text"
              class="ip-comm center"
              id="rtNum03"
              :value="posNo"
              @click="isPosKey = true"
            />
          </div>
          <div class="ip-row has-btn">
            <label for="rcNum">영수증번호</label>
            <input
              type="text"
              class="ip-comm left"
              id="rcNum"
              :value="receiptNo"
              @click="isReceiptKey = true"
            />
            <button type="button" class="btn-smd btn-main" @click="search">
              조회<span class="overlay"></span>
            </button>
          </div>
        </div>
        <div class="flex">
          <table class="tb-lst-payment tb-receipt">
            <thead>
              <tr>
                <td>No</td>
                <td>시간</td>
                <td>금액</td>
                <td>결제</td>
                <td>구분</td>
              </tr>
            </thead>
            <tbody id="receiptBody">
              <tr
                v-for="(receipt, i) in receiptList
                  .filter((item) => item.receiptDate == date2)
                  .filter((item) => (posNo != '' ? item.posNo == posNo : true))
                  .filter((item) =>
                    receiptNo != '' ? item.receiptNo == receiptNo : true
                  )"
                :key="receipt"
                :class="{ on: selectIdx == receipt.receiptIdx }"
                @click="receiptCheck(receipt)"
              >
                <td>{{ lpad(i + 1, 4, "0") }}</td>
                <td>{{ receipt.receiptTime }}</td>
                <td>
                  {{
                    receipt.amount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}
                </td>
                <td>{{ receipt.payType == "PAY001" ? "신용" : "현금" }}</td>
                <td>{{ receipt.type == "RCP001" ? "정상" : "반품" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="pop-btn-area with-scroll-btn col05">
        <div class="btn-arr-area">
          <button class="admin-btn-up" @click="scrollMove(-50)">
            <span class="overlay"></span>
          </button>
          <button class="admin-btn-down" @click="scrollMove(50)">
            <span class="overlay"></span>
          </button>
        </div>
        <button
          type="button"
          class="btn-pop btn-main"
          @click="
            if (
              receiptList.filter((item) => item.receiptIdx == selectIdx)
                .length > 0
            )
              isDetail = true;
          "
        >
          자세히 보기<span class="overlay"></span>
        </button>
        <button type="button" class="btn-pop btn-yellow" @click="rePrint">
          재출력<span class="overlay"></span>
        </button>
        <button type="button" class="btn-pop btn-yellow" @click="reOrder">
          반 품<span class="overlay"></span>
        </button>
      </div>
    </div>

    <Keypad
      v-if="isPosKey || isReceiptKey"
      @close="(isPosKey = false), (isReceiptKey = false)"
      @complete="complete"
    />
    <ReceiptDetail
      @rePrint="rePrint"
      @reOrder="reOrder"
      :receipt="receiptList.filter((item) => item.receiptIdx == selectIdx)[0]"
      v-if="isDetail"
      @close="isDetail = false"
    />

    <PopupBtn1
      style="position: static"
      v-if="isPopupBtn1"
      :popupText="popupText"
      :popupTitle="popupTitle"
      @close="isPopupBtn1 = false"
    />
  </div>
</template>

<script>
//json
import jsonReceiptList from "@/assets/json/ReceiptList.js";

import Datepicker from "vue3-datepicker";
import keypad from "@/components/popup/Keypad.vue";
import receiptDetail from "@/views/modal/ReceiptDetail.vue";
import popupBtn1 from "@/components/popup/PopupBtn1.vue";

export default {
  name: "receipt",
  props: {},
  data() {
    return {
      receiptList: jsonReceiptList.data.receiptList,
      posNo: "",
      receiptNo: "",
      isPosKey: false,
      isReceiptKey: false,
      date: new Date(),
      date2: "",
      selectIdx: 0,
      isDetail: false,
      isPopupBtn1: false,
      popupText: "",
      popupTitle: "",
      pickerStyle: {
        height: "40px",
        "font-weight": "bold",
        outline: "1px solid #5E6877",
        border: "1px solid #fff",
        "border-radius": "4px",
        "font-size": "16px",
        textAlign: "center",
        width: "120px",
      },
    };
  },
  methods: {
    receiptCheck(receipt) {
      this.selectIdx = receipt.receiptIdx;
      let baskets = JSON.parse(receipt.desc).menuArr;
      this.$emit("setReceiptBaskets", baskets);
    },
    scrollMove(moveY) {
      var scroll = document.getElementById("receiptBody");
      scroll.scrollTop += moveY;
    },
    rePrint() {
      if (
        this.receiptList.filter((item) => item.receiptIdx == this.selectIdx)
          .length == 0
      )
        return;
      this.popupTitle = "재출력";
      this.popupText = "재출력 되었습니다.";
      this.isPopupBtn1 = true;
    },
    reOrder() {
      if (
        this.receiptList.filter((item) => item.receiptIdx == this.selectIdx)
          .length == 0
      )
        return;
      let reorder = this.receiptList.filter(
        (item) => item.receiptIdx == this.selectIdx
      )[0];
      reorder.type = "RCP002";
      this.popupTitle = "반품";
      this.popupText = "반품 되었습니다.";
      this.isPopupBtn1 = true;
    },
    search() {
      let year = this.date.getFullYear();
      let month = ("0" + (this.date.getMonth() + 1)).slice(-2); // 월은 0부터 시작하기 때문에 +1이 필요하며, 항상 두 자리를 유지하기 위해 slice를 사용합니다.
      let day = ("0" + this.date.getDate()).slice(-2); // 일도 항상 두 자리를 유지하기 위해 slice를 사용합니다.

      this.date2 = year + "-" + month + "-" + day;
    },
    lpad(str, padLen, padStr) {
      str += ""; // 문자로
      padStr += ""; // 문자로
      while (str.length < padLen) str = padStr + str;
      str = str.length >= padLen ? str.substring(0, padLen) : str;
      return str;
    },
    complete(num) {
      if (this.isPosKey) this.posNo = num;
      else if (this.isReceiptKey) this.receiptNo = num;

      this.isPosKey = false;
      this.isReceiptKey = false;
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.search();
  },
  unmounted() {},
  components: {
    Datepicker,
    Keypad: keypad,
    ReceiptDetail: receiptDetail,
    PopupBtn1: popupBtn1,
  },
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


